<template>
  <div class="home">
    <div class="text-center m-4 logo">
      <img
        src="../assets/images/logotipo.png"
        alt="logo_dominos"
        id="logo_dominos"
      />
    </div>
    <Loading v-if="loading" />
    <div class="box">
      <div class="header"></div>
      <div class="body">
        <h1 class="text-center title">
          <img
            src="../assets/images/logo_pesquisa.png"
            alt="Logotipo Domino's"
            style="max-width: 100%"
            id="search_title"
          />
        </h1>
        <Navigation />
        <transition name="fadeTranslate">
          <div v-show="surveyEnded">
            <div class="thankyou">
              <img
                class="img-thankyou"
                src="../assets/images/obrigado-15k.png"
                alt="Obrigado"
                rel="prefetch"
              />
            </div>
            <!-- <span class="coupon-message">
              Você ganhou o cupom <strong>AR4FREE</strong> com direito à uma
              porção de alho roll grátis na compra de uma pizza.
            </span> -->
            <!--thankyou -->
          </div>
        </transition>
        <div>
          <div v-if="isPublicSurvey">
            <Question>
              <div class="question_step">
                <img src="../assets/images/estrelas.png" alt="estrela" />
                <label class="label_question question-label"
                  >Qual foi o seu canal de compra?</label
                >
                <img src="../assets/images/estrelas.png" alt="estrela" />
              </div>
              <div>
                <div class="radio_box_wrapper">
                  <div class="radioBox">
                    <!-- each radio input -->
                    <input type="radio" class="checkmark-radio" />
                    <span
                      @focus="iconFocus($event, 1, false)"
                      @blur="iconFocus($event, 1, true)"
                      class="pizzas type_single"
                      @click="selectPublicSurvey(1)"
                    ></span>
                    <p class="radio-legend">Telefone</p>
                  </div>
                  <!--radio-box-->
                  <div class="radioBox">
                    <!-- each radio input -->
                    <input type="radio" class="checkmark-radio" />

                    <span
                      @focus="iconFocus($event, 1, false)"
                      @blur="iconFocus($event, 1, true)"
                      class="pizzas type_single"
                      @click="selectPublicSurvey(2)"
                    ></span>
                    <p class="radio-legend">Balcão</p>
                  </div>
                  <!--radio-box-->

                  <!--radio-box-->
                  <div class="radioBox">
                    <!-- each radio input -->
                    <input type="radio" class="checkmark-radio" />

                    <span
                      @focus="iconFocus($event, 1, false)"
                      @blur="iconFocus($event, 1, true)"
                      class="pizzas type_single"
                      @click="selectPublicSurvey(3)"
                    ></span>
                    <p class="radio-legend">Whatsapp</p>
                  </div>
                  <!--radio-box-->

                  <!--radio-box-->
                  <div class="radioBox">
                    <!-- each radio input -->
                    <input type="radio" class="checkmark-radio" />

                    <span
                      @focus="iconFocus($event, 1, false)"
                      @blur="iconFocus($event, 1, true)"
                      class="pizzas type_single"
                      @click="callOnlineAlert()"
                    ></span>
                    <p class="radio-legend">Online</p>
                  </div>
                  <!--radio-box-->
                </div>
              </div>
            </Question>
          </div>

          <transition-group tag="div" name="questionAnimation">
            <Question
              v-for="(question, index) in noParentQuestions"
              :key="index"
              :id="index"
              v-show="++index == currentStep"
            >
              <div v-if="currentStep !== lastStep" class="question_step">
                <img src="../assets/images/estrelas.png" alt="estrela" />
                <label class="label_question question-label">{{
                  question.description
                }}</label>
                <img src="../assets/images/estrelas.png" alt="estrela" />
              </div>

               <div v-if="avoidOnlineSurvey() && showPhoneQuestion(question, index)">
                <div class="text_box_wrapper">
                  <template>
                    <input
                      type="text"
                      v-mask="'(##) #####-####'"
                      :id="`${question.id + '-' + question.type + '-' + index}`"
                      @input="
                        verifyTextInput(
                          $event,
                          'phone',
                          `${question.id + '-' + question.type + '-' + index}`
                        )
                      "
                    />
                  </template>

                  <btn
                    background="bg-primary-dominos"
                    v-on:click.native="nextStep($event, question, null, false)"
                    :id="`${
                      question.id + '-' + question.type + '-' + index
                    }-btn`"
                    :element="index"
                    :disabledBtn="true"
                    >Avançar</btn
                  >
                </div>
              </div> 

              <div v-if="avoidOnlineSurvey() && showEmailQuestion(question, index)">
                <div class="text_box_wrapper">
                  <template>
                    <input
                      type="text"
                      :id="`${question.id + '-' + question.type + '-' + index}`"
                      @input="
                        verifyTextInput(
                          $event,
                          'email',
                          `${question.id + '-' + question.type + '-' + index}`
                        )
                      "
                    />
                  </template>

                  <btn
                    background="bg-primary-dominos"
                    v-on:click.native="nextStep($event, question, null, false)"
                    :id="`${
                      question.id + '-' + question.type + '-' + index
                    }-btn`"
                    :element="index"
                    :disabledBtn="true"
                    >Avançar</btn
                  >
                </div>
              </div>

              <div
                v-if="
                avoidOnlineSurvey() && (
                  (question.type === typeFreeAnswer &&
                    index == 4 &&
                    states != null &&
                    getSurveyIdsDiffOperation()) ||
                  (question.type === typeFreeAnswer &&
                    index == 4 &&
                    states != null &&
                    getSurveyIdsEqualOperation()))
                "
              >
                <div class="text_box_wrapper">
                  <form
                    action
                    autocomplete="off"
                    novalidate
                    class="store_select"
                  >
                    <div>
                      <label for>Selecione o estado</label>
                      <select
                        class="browser-default custom-select"
                        autocomplete="off"
                        @change="getCities()"
                        v-model="store_state"
                      >
                        <option value selected disabled>
                          Selecione um estado
                        </option>
                        <option
                          v-for="(state, indexState) in states"
                          :key="indexState"
                          :value="state.UF"
                        >
                          {{ state.UF }}
                        </option>
                      </select>
                    </div>

                    <div class="mt-3" v-if="cities.length > 0">
                      <label for>Selecione a cidade</label>
                      <select
                        class="browser-default custom-select"
                        @change="getStores()"
                        v-model="store_city"
                      >
                        <option value disabled selected>
                          Selecione a cidade
                        </option>
                        <option
                          v-for="(citie, indexCity) in cities"
                          :key="indexCity"
                          :value="citie.city"
                        >
                          {{ citie.city }}
                        </option>
                      </select>
                    </div>

                    <div class="mt-3" v-if="stores.length > 0">
                      <label for>Selecione uma loja</label>
                      <select
                        class="browser-default custom-select"
                        v-model="order_store"
                      >
                        <option value disabled selected>
                          Selecione a loja
                        </option>
                        <option
                          v-for="(store, storeIndex) in stores"
                          :key="storeIndex"
                          :value="store.pulse_id"
                        >
                          {{ store.name }} ({{ store.street }})
                        </option>
                      </select>
                    </div>

                    <btn
                      background="bg-primary-dominos"
                      v-on:click.native="nextStep($event, question, null, true)"
                      :element="index"
                      :disabledBtn="order_store == ''"
                      >Avançar</btn
                    >
                  </form>
                </div>
              </div>

              <div v-if="question.type === typeSingleOptions">
                <div class="radio_box_wrapper">
                  <div
                    v-for="(option, key) in question.options"
                    :key="key"
                    class="radioBox"
                  >
                    <!-- each radio input -->
                    <input
                      type="radio"
                      :id="`${question.id + '-' + question.type + '-' + key}`"
                      :value="option.id"
                      class="checkmark-radio"
                    />

                    <span
                      @focus="iconFocus($event, index, false)"
                      @blur="iconFocus($event, index, true)"
                      @click="nextStep($event, question, index)"
                      :element="key"
                      :for="`${question.id + '-' + question.type + '-' + key}`"
                      class="pizzas type_single"
                      :belongs-to-question="index"
                    ></span>

                    <p class="radio-legend">{{ option.description }}</p>
                  </div>
                  <!--radio-box-->
                </div>
              </div>

              <div
                v-if="question.type === typeRating && question.max_rating <= 10"
              >
                <div class="radio_box_wrapper">
                  <div
                    v-for="(n, key) in question.max_rating + 1"
                    :key="key"
                    class="radioBox special-question"
                  >
                    <input
                      type="radio"
                      :id="`${question.id + '-' + question.type + '-' + key}`"
                      :value="key"
                      class="checkmark-radio"
                    />

                    <div
                      class="box-answer"
                      @focus="iconFocus($event, index, false)"
                      @blur="iconFocus($event, index, true)"
                      @click="nextStep($event, question, index)"
                      :for="`${question.id + '-' + question.type + '-' + key}`"
                      :element="key"
                      :belongs-to-question="index"
                    >
                      <span class="box-answer-value">{{ key }}</span>
                    </div>
                  </div>
                  <!--radio-box-->
                </div>

                <transition name="relationQuestionAnimation">
                  <div
                    :id="`check-container-${index}`"
                    v-if="childQuestions != null"
                    class="check-container"
                  >
                    <div class="relation_question_title_box">
                      <img src="../assets/images/estrelas.png" alt="estrela" />
                      <h2 class="relation_question_title">
                        {{ childQuestions.description }}
                      </h2>
                      <img src="../assets/images/estrelas.png" alt="estrela" />
                    </div>

                    <div
                      v-for="(option, key) in childQuestions.options"
                      :key="key"
                      class="check-item"
                      :belongs-to-step="index"
                    >
                      <input
                        @click="checkRelationQuestion($event)"
                        type="checkbox"
                        :optionId="option.id"
                      />
                      <p>{{ option.description }}</p>
                    </div>

                    <transition name="relationQuestionAnimation">
                      <div v-if="hasParentRelationQuestion != null">
                        <div class="relation_question_title_box mt-5">
                          <img
                            src="../assets/images/estrelas.png"
                            alt="estrela"
                          />
                          <h2 class="relation_question_title">
                            {{ hasParentRelationQuestion.description }}
                          </h2>
                          <img
                            src="../assets/images/estrelas.png"
                            alt="estrela"
                          />
                        </div>

                        <div class="relation_question_msg">
                          <textarea
                            :id="
                              'parent-relation-question-' +
                              hasParentRelationQuestion.id
                            "
                            :placeholder="hasParentRelationQuestion.description"
                            v-model="relationQuestionMsg"
                          ></textarea>
                        </div>
                      </div>
                    </transition>

                    <btn
                      background="bg-primary-dominos"
                      v-on:click.native="
                        nextStep($event, childQuestions, index)
                      "
                      :disabledBtn="
                        (answersMultiple.length === 0 &&
                          hasParentRelationQuestion == null) ||
                        (hasParentRelationQuestion != null &&
                          relationQuestionMsg == '')
                      "
                      >Avançar</btn
                    >
                  </div>
                </transition>
              </div>

              <div
                v-else-if="isLastQuestion(question.id)"
                class="range_question_type_box"
              >
                <textarea
                  class="last-textarea"
                  :id="`${
                    question.id +
                    '-' +
                    question.type +
                    '-' +
                    'last-question-desktop'
                  }`"
                ></textarea>

                <btn
                  background="bg-primary-dominos"
                  v-on:click.native="finishSurvey(question)"
                >
                  <span>Finalizar</span>
                </btn>
              </div>
              <!-- range -->
              <!-- finish -->
            </Question>
            <!-- Question Component -->
          </transition-group>
        </div>
      </div>
      <div class="footer"></div>
    </div>

    <!-- mobile -->

    <div class="card-wrapper">
      <div class="p-4 my-card form-wrapper-mobile" id="form">
        <h1 class="text-center mb-4">
          <img
            src="../assets/images/logo_pesquisa.png"
            alt="Logotipo Domino's"
            style="max-width: 100%"
            id="search_title"
          />
        </h1>
        <Navigation />
        <transition name="fadeTranslate">
          <div v-show="surveyEnded">
            <div class="thankyou">
              <img
                class="img-thankyou"
                src="../assets/images/obrigado-15k.png"
                alt="Obrigado"
                rel="prefetch"
              />
            </div>
            <!-- <span class="coupon-message">
              Você ganhou o cupom <strong>AR4FREE</strong> com direito à uma
              porção de alho roll grátis na compra de uma pizza.
            </span> -->
            <!--thankyou -->
          </div>
        </transition>

        <div v-if="isPublicSurvey">
          <Question>
            <div class="question_step">
              <label class="label_question question-label label_question_mobile"
                >Qual foi o seu canal de compra?</label
              >
            </div>
            <div class>
              <div class="radio_box_wrapper">
                <div class="radioBox">
                  <!-- each radio input -->
                  <input type="radio" class="checkmark-radio" />

                  <span
                    @focus="iconFocus($event, 1, false)"
                    @blur="iconFocus($event, 1, true)"
                    class="pizzas type_single"
                    @click="selectPublicSurvey(1)"
                  ></span>
                  <p class="radio-legend">Telefone</p>
                </div>
                <!--radio-box-->
                <div class="radioBox">
                  <!-- each radio input -->
                  <input type="radio" class="checkmark-radio" />

                  <span
                    @focus="iconFocus($event, 1, false)"
                    @blur="iconFocus($event, 1, true)"
                    class="pizzas type_single"
                    @click="selectPublicSurvey(2)"
                  ></span>
                  <p class="radio-legend">Balcão</p>
                </div>
                <!--radio-box-->

                <!--radio-box-->
                <div class="radioBox">
                  <!-- each radio input -->
                  <input type="radio" class="checkmark-radio" />

                  <span
                    @focus="iconFocus($event, 1, false)"
                    @blur="iconFocus($event, 1, true)"
                    class="pizzas type_single"
                    @click="selectPublicSurvey(3)"
                  ></span>
                  <p class="radio-legend">Whatsapp</p>
                </div>
                <!--radio-box-->

                <!--radio-box-->
                <div class="radioBox">
                  <!-- each radio input -->
                  <input type="radio" class="checkmark-radio" />

                  <span
                    @focus="iconFocus($event, 1, false)"
                    @blur="iconFocus($event, 1, true)"
                    class="pizzas type_single"
                    @click="callOnlineAlert()"
                  ></span>
                  <p class="radio-legend">Online</p>
                </div>
                <!--radio-box-->
              </div>
            </div>
          </Question>
        </div>

        <div>
          <transition-group tag="div" name="questionAnimation">
            <Question
              v-for="(question, index) in noParentQuestions"
              :key="index"
              :id="index"
              v-show="++index == currentStep"
            >
              <div v-if="currentStep !== lastStep" class="question_step">
                <label class="label_question question-label">{{
                  question.description
                }}</label>
              </div>

              <div v-if="avoidOnlineSurvey() && showPhoneQuestion(question, index)">
                <div class="text_box_wrapper">
                  <input
                    type="text"
                    v-mask="'(##) #####-####'"
                    :id="`${
                      question.id + '-' + question.type + '-' + (index + 490)
                    }`"
                    @input="
                      verifyTextInput(
                        $event,
                        'phone',
                        `${
                          question.id + '-' + question.type + '-' + index
                        }-mobile`
                      )
                    "
                  />
                  <btn
                    background="bg-primary-dominos"
                    v-on:click.native="nextStep($event, question, null, false)"
                    :id="`${
                      question.id + '-' + question.type + '-' + index
                    }-mobile-btn`"
                    :element="index + 490"
                    :disabledBtn="true"
                    >Avançar</btn
                  >
                </div>
              </div>

              <div v-if="avoidOnlineSurvey() && showEmailQuestion(question, index)">
                <div class="text_box_wrapper">
                  <input
                    type="text"
                    :id="`${
                      question.id + '-' + question.type + '-' + (index + 490)
                    }`"
                    @input="
                      verifyTextInput(
                        $event,
                        'email',
                        `${
                          question.id + '-' + question.type + '-' + index
                        }-mobile`
                      )
                    "
                  />
                  <btn
                    background="bg-primary-dominos"
                    v-on:click.native="nextStep($event, question, null, false)"
                    :id="`${
                      question.id + '-' + question.type + '-' + index
                    }-mobile-btn`"
                    :element="index + 490"
                    :disabledBtn="true"
                    >Avançar</btn
                  >
                </div>
              </div>

              <div
                v-if="
                avoidOnlineSurvey() && (
                  (question.type === typeFreeAnswer &&
                    index == 4 &&
                    states != null &&
                    getSurveyIdsDiffOperation()) ||
                  (question.type === typeFreeAnswer &&
                    index == 4 &&
                    states != null &&
                    getSurveyIdsEqualOperation()))
                "
              >
                <div class="text_box_wrapper">
                  <form
                    action
                    autocomplete="off"
                    novalidate
                    class="store_select"
                  >
                    <div>
                      <label for>Selecione o estado</label>
                      <select
                        class="browser-default custom-select"
                        autocomplete="off"
                        @change="getCities()"
                        v-model="store_state"
                      >
                        <option value selected disabled>
                          Selecione um estado
                        </option>
                        <option
                          v-for="(state, indexState) in states"
                          :key="indexState"
                          :value="state.UF"
                        >
                          {{ state.UF }}
                        </option>
                      </select>
                    </div>

                    <div class="mt-3" v-if="cities.length > 0">
                      <label for>Selecione a cidade</label>
                      <select
                        class="browser-default custom-select"
                        @change="getStores()"
                        v-model="store_city"
                      >
                        <option value disabled selected>
                          Selecione a cidade
                        </option>
                        <option
                          v-for="(citie, indexCity) in cities"
                          :key="indexCity"
                          :value="citie.city"
                        >
                          {{ citie.city }}
                        </option>
                      </select>
                    </div>

                    <div class="mt-3" v-if="stores.length > 0">
                      <label for>Selecione uma loja</label>
                      <select
                        class="browser-default custom-select"
                        v-model="order_store"
                      >
                        <option value disabled selected>
                          Selecione a loja
                        </option>
                        <option
                          v-for="(store, storeIndex) in stores"
                          :key="storeIndex"
                          :value="store.pulse_id"
                        >
                          {{ store.name }} ({{ store.street }})
                        </option>
                      </select>
                    </div>

                    <btn
                      background="bg-primary-dominos"
                      v-on:click.native="nextStep($event, question, null, true)"
                      :element="index"
                      :disabledBtn="order_store == ''"
                      >Avançar</btn
                    >
                  </form>
                </div>
              </div>

              <div v-if="question.type === typeSingleOptions">
                <div class="radio_box_wrapper">
                  <div
                    v-for="(option, key) in question.options"
                    :key="key"
                    class="radioBox"
                  >
                    <!-- each radio input -->
                    <input
                      type="radio"
                      :id="`${question.id + '-' + question.type + '-' + key}`"
                      :value="option.id"
                      class="checkmark-radio"
                    />
                    <span
                      @focus="iconFocus($event, index, false)"
                      @blur="iconFocus($event, index, true)"
                      @click="nextStep($event, question, index)"
                      :element="key"
                      :for="`${question.id + '-' + question.type + '-' + key}`"
                      class="pizzas type_single"
                      :belongs-to-question="index"
                    ></span>

                    <p class="radio-legend">{{ option.description }}</p>
                  </div>
                  <!--radio-box-->
                </div>
              </div>

              <div
                v-if="question.type === typeRating && question.max_rating <= 10"
              >
                <div class="radio_box_wrapper">
                  <div
                    v-for="(n, key) in question.max_rating + 1"
                    :key="key"
                    class="radioBox special-question"
                  >
                    <input
                      type="radio"
                      :id="`${question.id + '-' + question.type + '-' + key}`"
                      :value="key"
                      class="checkmark-radio"
                    />
                    <div
                      class="box-answer"
                      @focus="iconFocus($event, index, false)"
                      @blur="iconFocus($event, index, true)"
                      @click="nextStep($event, question, index)"
                      :for="`${question.id + '-' + question.type + '-' + key}`"
                      :element="key"
                      :belongs-to-question="index"
                    >
                      <span class="box-answer-value">{{ key }}</span>
                    </div>
                  </div>
                </div>

                <transition name="relationQuestionAnimation">
                  <div
                    :id="`check-container-${index}`"
                    v-if="childQuestions != null"
                    class="check-container"
                  >
                    <div class="relation_question_title_box">
                      <h2 class="relation_question_title">
                        {{ childQuestions.description }}
                      </h2>
                    </div>

                    <div
                      v-for="(option, key) in childQuestions.options"
                      :key="key"
                      class="check-item"
                      :belongs-to-step="index"
                    >
                      <input
                        @click="checkRelationQuestion($event)"
                        type="checkbox"
                        :optionId="option.id"
                      />
                      <p>{{ option.description }}</p>
                    </div>

                    <transition name="relationQuestionAnimation">
                      <div v-if="hasParentRelationQuestion != null">
                        <div class="relation_question_title_box mt-5">
                          <img
                            src="../assets/images/estrelas.png"
                            alt="estrela"
                          />
                          <h2 class="relation_question_title">
                            {{ hasParentRelationQuestion.description }}
                          </h2>
                          <img
                            src="../assets/images/estrelas.png"
                            alt="estrela"
                          />
                        </div>

                        <div class="relation_question_msg">
                          <textarea
                            :id="
                              'parent-relation-question-' +
                              hasParentRelationQuestion.id
                            "
                            :placeholder="hasParentRelationQuestion.description"
                            v-model="relationQuestionMsg"
                          ></textarea>
                        </div>
                      </div>
                    </transition>

                    <btn
                      background="bg-primary-dominos"
                      v-on:click.native="
                        nextStep($event, childQuestions, index)
                      "
                      :disabledBtn="
                        (answersMultiple.length === 0 &&
                          hasParentRelationQuestion == null) ||
                        (hasParentRelationQuestion != null &&
                          relationQuestionMsg == '')
                      "
                      >Avançar</btn
                    >
                  </div>
                </transition>
              </div>

              <div
                v-else-if="isLastQuestion(question.id)"
                class="range_question_type_box"
              >
                <!-- <div class="range_box_wrapper">
                  <span class="range_msg">Arraste e de uma nota de 0 à 10</span>
                  <span class="message_range_box">
                    <span
                      class="message_range_box_number"
                      v-if="!rangeDisabled"
                      >{{ rangeValue }}</span
                    >
                    <span class="message_range_box_text" v-if="rangeDisabled"
                      >Arraste e de uma nota de 0 à 10</span
                    >
                  </span>
                  <vue-slider
                    ref="slider"
                    class="range_slider_component"
                    style="margin-top: 40px"
                    @change="rangeDisabled = false"
                    v-model="rangeValue"
                    v-bind="options"
                  ></vue-slider>
                </div> -->

                <textarea
                  class="last-textarea"
                  :id="`${
                    question.id +
                    '-' +
                    question.type +
                    '-' +
                    'last-question-mobile'
                  }`"
                ></textarea>

                <!-- <transition name="relationQuestionAnimation">
                  <div v-if="lastRelationQuestion != null">
                    <div class="relation_question_title_box mt-5">
                      <img src="../assets/images/estrelas.png" alt="estrela" />
                      <h2 class="relation_question_title">
                        {{ lastRelationQuestion.description }}
                      </h2>
                      <img src="../assets/images/estrelas.png" alt="estrela" />
                    </div>

                    <div class="relation_question_msg">
                      <textarea
                        :id="
                          'mobile-parent-relation-question-' + lastQuestion.id
                        "
                      ></textarea>
                    </div>
                  </div>
                </transition> -->

                <btn
                  background="bg-primary-dominos"
                  v-on:click.native="finishSurvey(question)"
                  >Finalizar</btn
                >
              </div>
              <!-- range -->
            </Question>
            <!-- Question Component -->
          </transition-group>
        </div>
      </div>
      <!--card-->
    </div>
    <!--card-wrapper-->
  </div>
</template>

<script>
// components
import btn from "@/components/Button.vue";
import Question from "@/components/Question.vue";
import Navigation from "@/components/Navigation.vue";
import Loading from "@/components/Loading.vue";
import VueSlider from "vue-slider-component";

// objects
import Utils from "@/common/utils";
import { setTimeout } from "timers";
import { ApiService } from "@/common/api.service";
import axios from "axios";
import { mask } from "vue-the-mask";

// constants
import {
  SURVEY_ALREADY_ANSWERED,
  OFFLINE_SURVEY_URL,
  SURVEY_ALREADY_DONE,
  STORAGE_STEP,
  STORAGE_ANSWER,
  TOKEN_DOESNT_EXIST,
  PUBLIC_SURVEY,
  PUBLIC,
  PRIVATE,
} from "@/common/config";

// stylesheet
import "vue-slider-component/theme/material.css";

export default {
  name: "Home",
  components: {
    Question,
    Navigation,
    btn,
    VueSlider,
    Loading,
  },
  directives: { mask },
  data() {
    return {
      surveyObject: {},
      relationQuestionMsg: "",
      states: {},
      cities: "",
      stores: "",
      store_state: "",
      store_city: "",
      order_store: "",
      isPublicSurvey: false,
      loading: true,
      surveyType: "",
      surveyEnded: false,
      typeRating: 3,
      typeMultiple: 2,
      typeSingleOptions: 1,
      typeFreeAnswer: 4,
      questions: null,
      step: 0,
      currentStep: null,
      checkItemSelected: false,
      disableBtn: [],
      rangeValue: 0,
      rangeDisabled: true,
      lastStep: null,
      class: {
        checkItemSelected: "check-item-selected",
        pizzaOnFocus: "pizza_on_focus",
        pizzaOn: "pizza_on",
        boxAnswerOn: "box-answer-on",
      },
      answers: {
        token: "",
        questions: [],
      },
      parentRelationQuestionsAnswers: [],
      slug: "",
      childQuestions: null,
      noParentQuestions: [],
      hasParentQuestions: [],
      hasParentRelationQuestion: null,
      answersMultiple: [],
      lastQuestion: {},
      lastRelationQuestion: {},
      emailValid: false,
      options: {
        dotSize: 24,
        width: "auto",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        min: 0,
        max: 10,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "focus",
        tooltipPlacement: "top",
        tooltipFormatter: void 0,
        useKeyboard: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
    };
  },
  methods: {
    async getSurvey(survey_type = false, slug = false) {
      this.loading = true;

      try {
        const response =
          survey_type !== PUBLIC_SURVEY
            ? await ApiService.get(
                `participations/list-questions/${this.answers.token}`
              )
            : await ApiService.get(`surveys/list-public-questions/${slug}`);

        const states_response =
          survey_type === PUBLIC_SURVEY
            ? await axios.get("https://planob.dominos.com.br/lojas.php?uf=all")
            : null;
        this.states =
          states_response != null && survey_type === PUBLIC_SURVEY
            ? states_response.data.hits
            : null;
        const { data } = response;

        if (data.success) {
          this.surveyObject = data.survey ? data.survey : { id: data.participation.survey_id };
          this.loading = false;
          this.surveyType = !data.participation_status ? PUBLIC : PRIVATE;
          this.slug = slug;
          this.questions = !data.participation_status
            ? data.survey.questions
            : data.questions;
          this.noParentQuestions = this.questions.filter(
            (question) => question.parent_id == null
          );
          this.hasParentQuestions = this.questions.filter(
            (question) => question.parent_id != null
          );

          //Pega a ultima questao para colocar a questao relacionada a ultima questao pelo parent_id.
          this.lastQuestion =
            this.noParentQuestions[this.noParentQuestions.length - 1];

          this.lastRelationQuestion = this.hasParentQuestions.filter(
            (question) => question.parent_id == this.lastQuestion.id
          )[0];

          this.$store.state.stepsQuantity = this.noParentQuestions.length;
          this.lastStep = this.noParentQuestions.length + 1;

          if (localStorage.Step && localStorage.Answers && localStorage.Token) {
            if (this.answers.token != JSON.parse(localStorage.Token)) {
              this.currentStep = 1;
              this.$store.state.stepAtual = 1;
              this.clearStorage();
            } else {
              this.currentStep = JSON.parse(localStorage.Step);
              this.$store.state.stepAtual = JSON.parse(localStorage.Step);
              this.answers = JSON.parse(localStorage.Answers);
            }
          } else if (
            localStorage.Step &&
            localStorage.Answers &&
            !localStorage.Token &&
            !data.participation_status
          ) {
            this.currentStep = JSON.parse(localStorage.Step);
            this.$store.state.stepAtual = JSON.parse(localStorage.Step);
            this.answers = JSON.parse(localStorage.Answers);
          } else {
            this.currentStep = 1;
            this.$store.state.stepAtual = 1;
            this.clearStorage();
            localStorage.Answers = JSON.stringify(this.answers);

            if (this.surveyType == PRIVATE) {
              localStorage.Token = JSON.stringify(this.answers.token);
            } else {
              localStorage.slug = JSON.stringify(this.slug);
            }
          }
        } else if (
          !data.success &&
          data.participation_status === TOKEN_DOESNT_EXIST
        ) {
          this.loading = false;
          this.currentStep = 1;
          this.$store.state.stepAtual = 1;
          this.clearStorage(OFFLINE_SURVEY_URL, data.message);
        } else if (
          !data.success &&
          data.participation_status === SURVEY_ALREADY_ANSWERED
        ) {
          this.loading = false;
          this.currentStep = 1;
          this.$store.state.stepAtual = 1;
          this.clearStorage(SURVEY_ALREADY_DONE, data.message);
        } else {
          this.currentStep = 1;
          this.$store.state.stepAtual = 1;
          this.loading = false;
          this.clearStorage(SURVEY_ALREADY_DONE);
        }
        return;
      } catch (err) {
        this.loading = false;
        this.$router.push(OFFLINE_SURVEY_URL);
        return;
      }
    },

    avoidOnlineSurvey () {
      return Boolean(this.surveyObject.id !==  15)
    },

    getSurveyIdsEqualOperation() {
      const surveyId = this.surveyObject.id;
      return (
        surveyId == 6 ||
        surveyId == 8 ||
        surveyId == 9 ||
        surveyId == 10 ||
        surveyId == 12 ||
        surveyId == 13 ||
        surveyId == 15 ||
        surveyId == 16 ||
        surveyId == 17 ||
        surveyId == 18
      );
    },

    getSurveyIdsDiffOperation() {
      const surveyId = this.surveyObject.id;
      return (
        surveyId != 8 &&
        surveyId != 6 &&
        surveyId != 9 &&
        surveyId != 10 &&
        surveyId != 12 &&
        surveyId != 13 &&
        surveyId != 15 &&
        surveyId != 16 &&
        surveyId != 17 &&
        surveyId != 18
      );
    },

    showEmailQuestion(question, index) {
      return (
        (question.type === this.typeFreeAnswer &&
          index == 3 &&
          this.getSurveyIdsDiffOperation()) ||
        (question.type === this.typeFreeAnswer &&
          index == 3 &&
          this.getSurveyIdsEqualOperation())
      );
    },

    showPhoneQuestion(question, index) {
      return (
        question.type === this.typeFreeAnswer &&
        index == 2 &&
        this.getSurveyIdsEqualOperation()
      );
    },

    isLastQuestion(id) {
      return (
        id === 115 ||
        id === 123 ||
        id === 130 ||
        id === 147 ||
        id === 154 ||
        id === 161 ||
        id === 168
      );
    },

    async finishSurvey(question) {
      this.loading = true;
      let surveyAnswer;
      let responseText = "";

      const textAreaDesktop = document.getElementById(
        `${question.id}-${question.type}-last-question-desktop`
      );
      if (textAreaDesktop.value == "") {
        responseText = document.getElementById(
          `${question.id}-${question.type}-last-question-mobile`
        ).value;
      } else {
        responseText = textAreaDesktop.value;
      }

      this.answers.questions.push({
        question_id: question.id,
        type: question.type,
        response_text: responseText,
      });

      localStorage.setItem(STORAGE_ANSWER, JSON.stringify(this.answers));

      if (this.surveyType === PRIVATE) {
        surveyAnswer = this.answers;
      } else {
        const email = this.answers.questions[0].response_text;
        surveyAnswer = {
          store_id: JSON.parse(localStorage.getItem("store_id")),
          customer_email: email,
          slug: this.slug,
          questions: this.answers.questions,
        };
      }

      try {
        const response = await ApiService.post(
          "participations/save-question",
          surveyAnswer
        );
        const { data } = response;
        this.loading = false;

        if (data.success) {
          this.currentStep++;
          this.$store.state.stepAtual++;
          this.surveyEnded = true;
          this.clearStorage();
        } else if (
          !data.success &&
          data.participation_status === this.TOKEN_DOESNT_EXIST
        ) {
          this.currentStep = 1;
          this.$store.state.stepAtual = 1;
          this.clearStorage(OFFLINE_SURVEY_URL, data.message);
        } else {
          this.currentStep = 1;
          this.$store.state.stepAtual = 1;
          this.clearStorage(OFFLINE_SURVEY_URL);
        }
      } catch (err) {
        this.loading = false;
        this.clearStorage(OFFLINE_SURVEY_URL);
      }
    },

    iconFocus(event, questionIndex, remove) {
      const target = event.target;
      const elSelectedNumber = Number(target.getAttribute("element"));
      document.querySelectorAll("span.pizzas").forEach((item) => {
        const elNumber = Number(item.getAttribute("element"));
        if (
          Number(questionIndex) ==
          Number(item.getAttribute("belongs-to-question"))
        ) {
          if (!remove && elNumber <= elSelectedNumber) {
            item.classList.add(this.class.pizzaOnFocus);
          } else if (remove && elNumber <= elSelectedNumber) {
            item.classList.remove(this.class.pizzaOnFocus);
          }
        }
      });
    },

    iconHover(event, questionIndex, remove) {
      const target = event.target;
      const elSelectedNumber = Number(target.getAttribute("element"));

      document.querySelectorAll(".box-answer").forEach((item) => {
        const elNumber = Number(item.getAttribute("element"));
        if (
          Number(questionIndex) ==
          Number(item.getAttribute("belongs-to-question"))
        ) {
          if (!remove && elNumber <= elSelectedNumber) {
            item.classList.add(this.class.boxAnswerOn);
          } else if (remove && elNumber <= elSelectedNumber) {
            item.classList.remove(this.class.boxAnswerOn);
          }
        }
      });
    },

    animateOnScroll(pxScroll, animationType) {
      return (
        // eslint-disable-next-line no-undef
        $("html, body").animate({ scrollTop: pxScroll }, animationType)
      );
    },

    clearStorage(redirectError = false, redirectMessage = false) {
      localStorage.removeItem(STORAGE_STEP),
        localStorage.removeItem(STORAGE_ANSWER);

      if (redirectError) {
        if (redirectMessage) {
          this.$store.state.request_message = redirectMessage;
        }
        this.$router.push(redirectError);
      }

      return;
    },

    nextStep(
      event = null,
      question = null,
      questionIndex = null,
      isSelect = false
    ) {
      this.childQuestions = null;

      //recupera a resposta caso tenha pergunta relacionada a pergunta relacionada.
      if (this.hasParentRelationQuestion != null) {
        var textarea = document.getElementById(
          "parent-relation-question-" + this.hasParentRelationQuestion.id
        );
        let parentRelationQuestionAnswer = {
          question_id: this.hasParentRelationQuestion.id,
          type: this.hasParentRelationQuestion.type,
          response_text: textarea.value,
        };
        this.answers.questions.push(parentRelationQuestionAnswer);
        this.hasParentRelationQuestion = null;
        this.relationQuestionMsg = "";
        // this.parentRelationQuestionsAnswers.push(parentRelationQuestionAnswer);
      }

      const target = event ? event.currentTarget : null;
      const elSelectedNumber =
        target != null ? Number(target.getAttribute("element")) : null;
      const elementId =
        question != null
          ? `${question.id + "-" + question.type + "-" + elSelectedNumber}`
          : null;
      let selectedElement =
        elementId != null ? document.getElementById(elementId) : null;

      //Montando o array de respostas
      const answer = {
        question_id: question.id,
        type: question.type,
      };

      switch (question.type) {
        case this.typeSingleOptions:
          selectedElement.checked = true;
          answer.options = [selectedElement.value];
          document.querySelectorAll("span.pizzas").forEach((span) => {
            const elNumber = Number(span.getAttribute("element"));
            if (
              Number(questionIndex) ===
              Number(span.getAttribute("belongs-to-question"))
            ) {
              span.classList.remove("pizza_selected");
              if (elNumber == elSelectedNumber) {
                span.classList.add("pizza_selected");
              }
            }
          });
          break;
        case this.typeRating:
          selectedElement.checked = true;
          document.querySelectorAll(".box-answer").forEach((span) => {
            const elNumber = Number(span.getAttribute("element"));
            if (
              Number(questionIndex) ===
              Number(span.getAttribute("belongs-to-question"))
            ) {
              span.classList.remove("box-answer-selected");
              if (elNumber === elSelectedNumber) {
                span.classList.add("box-answer-selected");
              }
            }
          });

          answer.rating = selectedElement.value;
          break;
        case this.typeMultiple:
          answer.options = this.answersMultiple;
          this.answersMultiple = [];
          break;
        case this.typeFreeAnswer:
          if (!isSelect) {
            answer.response_text = selectedElement.value;
          } else {
            answer.response_text = this.order_store;
            localStorage.setItem(
              "store_id",
              JSON.stringify(answer.response_text)
            );
          }
          this.answersMultiple = [];
          break;
      }

      const storageAnswers = JSON.parse(localStorage.getItem(STORAGE_ANSWER));
      const storageAnswersQuestions = storageAnswers.questions;
      const foundAnswer = storageAnswersQuestions.find(
        (element) => element.question_id == answer.question_id
      );

      if (foundAnswer != undefined) {
        this.answers.questions[this.answers.questions.length - 1].rating =
          answer.rating;
      } else {
        this.answers.questions.push(answer);
      }

      localStorage.setItem(STORAGE_ANSWER, JSON.stringify(this.answers));

      if (question.type == this.typeRating && answer.rating <= 6) {
        // TO DO retornar todos os elementos do filter
        // e transformar childQuestions em um array no data
        this.childQuestions = this.hasParentQuestions.filter(
          (childQuestion) => childQuestion.parent_id == question.id
        )[0];
        if (!this.childQuestions) {
          setTimeout(() => {
            this.$store.state.stepAtual++;
            this.currentStep++;
            localStorage.setItem(
              STORAGE_STEP,
              JSON.stringify(this.currentStep)
            );
            return;
          }, 300);
        }
        this.animateOnScroll(1000, "slow");
      } else if (question.type == this.typeRating && answer.rating >= 7) {
        this.childQuestions = this.hasParentQuestions.filter(
          (childQuestion) => childQuestion.parent_id == question.id
        )[1];
        if (!this.childQuestions) {
          setTimeout(() => {
            this.$store.state.stepAtual++;
            this.currentStep++;
            localStorage.setItem(
              STORAGE_STEP,
              JSON.stringify(this.currentStep)
            );
            return;
          }, 300);
        }
        this.animateOnScroll(1000, "slow");
      } else if (question.type == this.typeSingleOptions) {
        setTimeout(() => {
          this.$store.state.stepAtual++;
          this.currentStep++;
          localStorage.setItem(STORAGE_STEP, JSON.stringify(this.currentStep));
          return;
        }, 300);
      } else {
        setTimeout(() => {
          this.$store.state.stepAtual++;
          this.currentStep++;
          this.animateOnScroll(0, "slow");
          localStorage.setItem(STORAGE_STEP, JSON.stringify(this.currentStep));
          return;
        }, 300);
      }
    },

    checkRelationQuestion(event) {
      const checkItem = event.target;
      const optionId = checkItem.getAttribute("optionId");

      let parentRelationQuestion;

      this.hasParentQuestions.forEach((question) => {
        if (question.options.length != 0) {
          let options = question.options;
          let option = options.filter((item) => item.id == optionId);
          if (option.length != 0) {
            parentRelationQuestion = question;
          }
        }
      });

      let biggestId = -1;
      for (let i = 0; i < parentRelationQuestion.options.length; i++) {
        if (parentRelationQuestion.options[i].id > biggestId) {
          biggestId = parentRelationQuestion.options[i].id;
        }
      }

      if (biggestId == optionId) {
        if (
          parentRelationQuestion != null ||
          parentRelationQuestion != undefined
        ) {
          this.hasParentRelationQuestion = this.hasParentQuestions.filter(
            (item) => item.parent_id === parentRelationQuestion.id
          )[0];
        }
      }

      if (checkItem.checked == true) {
        checkItem.parentElement.classList.add(this.class.checkItemSelected);
        this.answersMultiple.push(optionId);
        return;
      }

      checkItem.parentElement.classList.remove(this.class.checkItemSelected);

      if (Number(checkItem.getAttribute("optionid")) == biggestId) {
        this.hasParentRelationQuestion = null;
      }

      this.answersMultiple = this.answersMultiple.filter(
        (option) => option != optionId
      );
      return;
    },

    verifyTextInput(event, inputType, element) {
      const inputValue = event.target.value;
      const button = document.getElementById(element + "-btn");
      switch (inputType) {
        case "email":
          button.disabled = Utils.validateEmail(inputValue) ? false : true;
          break;
        case "phone":
          if (inputValue.length >= 14) {
            button.disabled = false;
          }
          break;
      }
    },

    async getCities() {
      this.loading = true;
      this.store_city = "";
      this.order_store = "";
      const uf = this.store_state;
      const { data } = await axios.get(
        `https://planob.dominos.com.br/lojas.php?uf=${uf}&city=all`
      );
      const cities = data.hits;
      cities.forEach((item) => {
        item.city = item.city.toUpperCase();
      });
      this.cities = cities;
      this.loading = false;
    },

    async getStores() {
      this.loading = true;
      this.order_store = "";
      const uf = this.store_state;
      const city = this.store_city;
      const { data } = await axios.get(
        `https://planob.dominos.com.br/lojas.php?uf=${uf}&city=${city}`
      );
      this.stores = data.hits;
      this.stores.forEach((item) => {
        item.name = item.name.toUpperCase();
      });
      this.loading = false;
      if (this.stores.length == 1) {
        this.order_store = this.stores[0].pulse_id;
        localStorage.setItem("store_id", JSON.stringify(this.order_store));
      }
    },

    selectPublicSurvey(answer) {
      switch (answer) {
        case 1:
          this.clearStorage();
          window.location.href = "/pesquisa-publica/pesquisa-de-telefone";
          break;
        case 2:
          this.clearStorage();
          window.location.href = "/pesquisa-publica/pesquisa-de-balcao";
          break;
        case 3:
          this.clearStorage();
          window.location.href = "/pesquisa-publica/pesquisa-de-whatsapp";
          break;
      }
    },

    callOnlineAlert() {
      /*eslint-disable */
      return swal({
        title: "Atenção",
        dangerMode: true,
        text: "Opa! Em até 3 horas você irá receber a pesquisa em seu e-mail.",
        button: "OK",
      });
    },
  },

  created() {
    if (this.$route.params.token) {
      this.answers.token = this.$route.params.token;
      this.getSurvey();
    } else if (
      !this.$route.params.token &&
      this.$route.meta.publicSurvey &&
      this.$route.params.slug
    ) {
      this.getSurvey(PUBLIC_SURVEY, this.$route.params.slug);
    } else if (
      !this.$route.params.token &&
      !this.$route.params.slug &&
      this.$route.meta.publicSurvey
    ) {
      setTimeout(() => {
        this.loading = false;
        this.isPublicSurvey = true;
      }, 500);
    } else {
      this.$router.push(OFFLINE_SURVEY_URL);
    }
  },
};
</script>

<style scoped>
.first_radio_box_wrapper {
  width: 70%;
  margin: 0 auto;
}

.first_radio_box span.pizzas {
  width: 100%;
}

.first_radio_box .radio-legend {
  font-size: 22px;
}

div.box {
  min-height: 700px;
  height: auto;
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

div.body > .title {
  position: relative;
  top: -20px;
}

div.box > .header {
  width: 100%;
  height: 59px;
  background-image: url("../assets/images/topo.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

div.box > .body {
  background: url("../assets/images/repeat-meio.png") repeat;
  width: 100%;
  flex: 1;
  padding: 20px 4%;
}

div.box > .footer {
  background: url("../assets/images/rodape.png") repeat;
  width: 100%;
  height: 59px;
}

.home {
  padding: 0 2%;
}

.questionAnimation-enter,
.questionAnimation-leave-to {
  opacity: 0;
}

.questionAnimation-enter {
  display: none;
}

.questionAnimation-enter {
  transform: translate3d(0, -20px, 0);
}

.questionAnimation-enter-active,
.questionAnimation-leave-active {
  transition: all 0.5s;
  display: none;
}

.questionAnimation-enter-active {
  display: block;
}

.questionAnimation-leave-active {
  transition-delay: 1s;
  transform: translate3d(0, 20px, 0);
}

.relationQuestionAnimation-enter,
.relationQuestionAnimation-leave-to,
.fadeTranslate-enter,
.fadeTranslate-leave-to {
  opacity: 0;
}

.relationQuestionAnimation-enter,
.fadeTranslate-enter {
  transform: translate3d(0, -20px, 0);
}

.relationQuestionAnimation-leave-to,
.fadeTranslate-leave-to {
  transform: translate3d(0, 20px, 0);
}

.relationQuestionAnimation-enter-active,
.relationQuestionAnimation-leave-active,
.fadeTranslate-enter-active,
.fadeTranslate-leave-active {
  transition: all 0.5s;
}

.my-card {
  max-width: 660px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  min-height: 700px;
  box-shadow: none;
  border: 2px solid #006491;
  border-radius: 0px;
}

.card-wrapper {
  max-width: 660px;
  margin: 0 auto;
  background-color: #fff;
  padding: 10px;
  margin-bottom: 20px;
  display: none;
}

span.message_range_box_number {
  font-size: 40px !important;
}

.message_range_box > span {
  font-size: 23px;
}

.message_range_box_text {
  font-size: 23px;
  color: #bbb;
}

.relation_question_msg textarea {
  display: block;
  margin: 0 auto;
  width: 100%;
  font-size: 1.4rem;
  padding: 10px;
  height: 100px;
  resize: none;
  border: 2px solid #006491;
}

@media screen and (max-width: 1050px) {
  div.box {
    display: none;
  }

  .card-wrapper {
    display: block;
  }

  .my-card {
    min-height: 0;
  }
}

@media screen and (max-width: 768px) {
  .my-card {
    max-width: 600px;
  }

  .card-wrapper {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
  }
}

@media screen and (max-width: 680px) {
  .my-card {
    max-width: 100% !important;
    height: auto;
  }

  .card-wrapper {
    max-width: none;
    margin-bottom: 70px;
  }

  .logo img {
    max-width: 300px;
  }
}

@media screen and (max-width: 580px) {
  span.message_range_box_number {
    font-size: 40px !important;
  }

  .message_range_box_text {
    font-size: 23px;
  }

  .logo {
    margin: 0px !important;
    padding: 20px;
  }

  .first_radio_box.radioBox {
    width: 25% !important;
  }

  .label_question_mobile {
    font-size: 24px;
  }

  .first_radio_box .radio-legend {
    margin-top: -5px;
  }
}

@media screen and (max-width: 380px) {
  .logo img {
    max-width: 200px;
  }

  span.message_range_box_number {
    font-size: 35px !important;
  }

  .message_range_box_text {
    font-size: 20px;
  }
}

.box_span {
  display: block;
  height: 30px;
}

.last-textarea {
  display: block;
  margin: 0 auto;
  width: 100%;
  font-size: 1.4rem;
  padding: 10px;
  height: 100px;
  resize: none;
  border: 2px solid #006491;
}

.special-question {
  margin-right: 5px;
}

.special-question:nth-last-of-type() {
  margin-right: 0px;
}

div.box-answer {
  background-color: #006491;
  color: #fff;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.1s ease-in-out;
}

div.box-answer:hover {
  opacity: 0.8;
}

.box-answer-value {
  position: relative;
  top: 4px;
  font-size: 22px;
}

div.box-answer.box-answer-on {
  background-color: #e31837;
}

div.box-answer-selected {
  background-color: #e31837;
}

.coupon-message {
  display: block;
  font-size: 21px;
  text-align: center;
  line-height: 25px;
  max-width: 65%;
  margin: 0 auto;
}

.coupon-message strong {
  color: #006491;
  font-weight: bold;
}

@media screen and (max-width: 1050px) {
  div.box-answer {
    height: 35px;
  }
}

@media screen and (max-width: 768px) {
  .form-wrapper-mobile {
    padding: 0.5rem !important;
  }

  .coupon-message {
    max-width: 80%;
    margin-bottom: 20px;
  }

  #search_title {
    margin-top: 20px;
  }
}

div.box-answer[element="0"] {
  background-color: #a02d30 !important;
}
div.box-answer[element="1"] {
  background-color: #d0252e !important;
}
div.box-answer[element="2"] {
  background-color: #e35531 !important;
}
div.box-answer[element="3"] {
  background-color: #e4753e !important;
}
div.box-answer[element="4"] {
  background-color: #f4a738 !important;
}
div.box-answer[element="5"] {
  background-color: #f9c649 !important;
}
div.box-answer[element="6"] {
  background-color: #e9da42 !important;
}
div.box-answer[element="7"] {
  background-color: #e2e354 !important;
}
div.box-answer[element="8"] {
  background-color: #c2d257 !important;
}
div.box-answer[element="9"] {
  background-color: #afcd49 !important;
}
div.box-answer[element="10"] {
  background-color: #6bb05b !important;
}
</style>

